import { Bird, Rabbit, Squirrel, Leaf, Heart, Award } from "lucide-react";
import { Reveal, EUFlag } from "./Extras";
import { WHY_IMAGE } from "../data/content";

const Why = () => (
    <section id="por-que" data-testid="why-section" className="bg-white py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal className="max-w-2xl">
                <p className="text-sm font-bold uppercase tracking-widest text-brand-magenta">¿Por qué LoloPets?</p>
                <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">
                    Ingredientes con función y propósito
                </h2>
                <p className="mt-4 text-base leading-relaxed text-brand-muted">
                    Los productos de LoloPets tienen ingredientes pensados en mejorar la salud y el
                    bienestar de tu mascota. Esta es la calidad que nuestras mascotas se merecen.
                </p>
            </Reveal>

            <div className="mt-8 grid gap-4 md:grid-cols-3 md:gap-6">
                <Reveal className="md:col-span-2">
                    <div className="flex h-full flex-col justify-between overflow-hidden rounded-2xl bg-brand-purple p-8 shadow-soft md:flex-row md:items-center md:gap-8">
                        <div className="max-w-md">
                            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white">
                                <EUFlag /> Calidad Europea
                            </span>
                            <h3 className="mt-5 font-display text-2xl font-bold text-white sm:text-3xl">
                                Formulación europea, nutrición completa
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-white/75">
                                Cada receta nace de estándares europeos de nutrición animal: nada sobra,
                                nada falta. Cada ingrediente cumple una función concreta en la salud de tu mascota.
                            </p>
                        </div>
                        <img
                            src={WHY_IMAGE}
                            alt="Alimento premium LoloPets con ingredientes naturales"
                            className="mt-6 w-full rounded-2xl object-cover md:mt-0 md:h-48 md:w-64"
                            loading="lazy"
                        />
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="flex h-full flex-col justify-center rounded-2xl bg-brand-cream p-8 shadow-soft">
                        <Award className="h-9 w-9 text-brand-magenta" />
                        <h3 className="mt-4 font-display text-xl font-semibold text-brand-ink">Líneas especializadas</h3>
                        <p className="mt-2 text-sm leading-relaxed text-brand-muted">
                            Foody Premium, Smakers y Bloomy: alimento completo, premios y complementos por especie.
                        </p>
                    </div>
                </Reveal>
                {[
                    { icon: Bird, title: "Aves", text: "Canarios, periquitos, ninfas, cacatúas y periquitos de amor.", id: "aves" },
                    { icon: Rabbit, title: "Conejos", text: "Alimento completo y heno para digestión y desgaste dental.", id: "conejos" },
                    { icon: Squirrel, title: "Roedores", text: "Hámsters y pequeños roedores: heno, zacate, túneles y mixes.", id: "roedores" },
                ].map(({ icon: Icon, title, text, id }, i) => (
                    <Reveal key={id} delay={0.08 * i}>
                        <a
                            data-testid={`why-category-${id}`}
                            href={`#productos`}
                            className="group flex h-full flex-col rounded-2xl bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-magenta/10 text-brand-magenta transition-colors duration-300 group-hover:bg-brand-magenta group-hover:text-white">
                                <Icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-4 font-display text-xl font-semibold text-brand-ink">{title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-brand-muted">{text}</p>
                        </a>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1} className="mt-6 grid gap-4 md:grid-cols-2 md:gap-6">
                <div className="flex items-start gap-4 rounded-2xl bg-white p-7 shadow-soft">
                    <Leaf className="mt-1 h-7 w-7 shrink-0 text-brand-magenta" />
                    <div>
                        <h3 className="font-display text-lg font-semibold text-brand-ink">Nada artificial por gusto</h3>
                        <p className="mt-1 text-sm leading-relaxed text-brand-muted">
                            Semillas, heno, minerales y premios pensados para la dieta real de cada especie.
                        </p>
                    </div>
                </div>
                <div className="flex items-start gap-4 rounded-2xl bg-white p-7 shadow-soft">
                    <Heart className="mt-1 h-7 w-7 shrink-0 text-brand-magenta" />
                    <div>
                        <h3 className="font-display text-lg font-semibold text-brand-ink">Bienestar primero</h3>
                        <p className="mt-1 text-sm leading-relaxed text-brand-muted">
                            Del alimento completo al enriquecimiento ambiental: todo para mascotas activas y felices.
                        </p>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Why;
